export default {
  title: 'Einstellungen',
};
